import * as React from 'react';

import { Flex, Loader } from '@opendoor/bricks/core';

const LoadingSection: React.FC = () => (
  <div className="container">
    <div className="row">
      <div className="col-xs-12">
        <Flex
          position="absolute"
          left={0}
          top={0}
          width="100%"
          height="100%"
          m={0}
          p={0}
          justifyContent="center"
          alignItems="center"
        >
          <Loader />
        </Flex>
      </div>
    </div>
  </div>
);

export default LoadingSection;
